import styled from "styled-components";
import { TypographyV2 } from "config/font";
import { ColorV2 } from "config/colors";

export interface TextProps {
  typography: keyof typeof TypographyV2;
  color?: ColorV2;
  align: "left" | "right" | "center";
}

export const Text = styled.span<TextProps>`
  ${({ typography }) => TypographyV2[typography]};
  color: ${(props) => props.color ?? ColorV2.Blue1};
  text-align: ${(props) => props.align ?? "left"};
`;
